<template>
  <nav class="nav">
    <div class="nav__container">
      <router-link to="/" class="nav__logo">
        <img src="@/assets/logo.png" alt="Grace Baptist Church Walkerville Logo" class="nav__logo-img">
      </router-link>
      
      <!-- Burger Menu Button -->
      <button class="nav__burger" @click="toggleMenu" :class="{ 'is-active': isMenuOpen }">
        <span class="nav__burger-line"></span>
        <span class="nav__burger-line"></span>
        <span class="nav__burger-line"></span>
        <span class="sr-only">Menu</span>
      </button>

      <!-- Navigation Links -->
      <div class="nav__links" :class="{ 'nav__links--open': isMenuOpen }">
        <router-link to="/" class="nav__link" @click="closeMenu">Home</router-link>
        <router-link to="/beliefs" class="nav__link" @click="closeMenu">What We Believe</router-link>
        <router-link to="/schedule" class="nav__link" @click="closeMenu">Schedule</router-link>
        <!-- Add more links as needed -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavigationComponent',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : ''
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 50;
  
  &__container {
    max-width: 64rem;
    margin: 0 auto;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__logo {
    text-decoration: none;
    z-index: 60;
    
    &-img {
      height: 50px;
      width: auto;
    }
  }

  &__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    width: 30px;
    height: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 60;
    position: relative;

    &-line {
      display: block;
      width: 100%;
      height: 2px;
      background-color: #1e40af;
      position: absolute;
      left: 0;
      transition: all 0.4s ease;
      transform-origin: center;

      &:first-child {
        top: 4px;
      }

      &:nth-child(2) {
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
      }

      &:last-child {
        bottom: 4px;
      }
    }

    &.is-active {
      .nav__burger-line {
        &:first-child {
          transform: translateY(8px) rotate(90deg);
          width: 24px;
          left: 3px;
        }
        &:nth-child(2) {
          transform: rotate(0deg);
          width: 30px;
        }
        &:last-child {
          transform: translateY(-8px);
          opacity: 0;
        }
      }
    }
  }

  &__links {
    display: flex;
    gap: 1.5rem;
  }

  &__link {
    color: #1f2937;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;

    &:hover {
      color: #1e40af;
    }

    &.router-link-active {
      color: #1e40af;
    }
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@media (max-width: 768px) {
  .nav {
    &__burger {
      display: flex;
    }

    &__links {
      position: fixed;
      top: 0;
      right: -100%;
      height: 100vh;
      width: 100%;
      background-color: white;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transition: right 0.3s ease;
      gap: 2rem;

      &--open {
        right: 0;
      }
    }

    &__link {
      font-size: 1.25rem;
    }
  }
}
</style> 